<template>
  <ArtisanGrid ref="shift" metaKey="JyShiftInfo" :query="query"> </ArtisanGrid>
</template>

<script>
export default {
  props:["query"]
};
</script>

<style>
</style>